/**
 * @generated SignedSource<<e2c4fb73be6f80bb113203a6beea6f57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "serviceId"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceById",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mrchntd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Pool",
        "kind": "LinkedField",
        "name": "pools",
        "plural": true,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseCheckoutPagesServiceQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseCheckoutPagesServiceQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bfe27d6106c914ce80c608db2f0fbbe3",
    "id": null,
    "metadata": {},
    "name": "ImpulseCheckoutPagesServiceQuery",
    "operationKind": "query",
    "text": "query ImpulseCheckoutPagesServiceQuery(\n  $serviceId: String\n) {\n  serviceById(id: $serviceId) {\n    id\n    mrchntd\n    pools {\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "7e8cedfdc6551bc29087150d6b119057";

module.exports = node;
